import { Link } from 'react-router-dom';
/** Keep market navigation separate from the optional read-only account record.
 * A missing local book does not prove Game Detail cannot receive its feed. */
export function UnavailableCardBookNotice({ ticker, href, onDismiss, onViewRecord }: {
  ticker: string;
  href: string | null;
  onDismiss: () => void;
  onViewRecord?: (trigger: HTMLElement) => void;
}) {
  return (
    <div role="status" aria-label="Selected contract unavailable" className="border-border bg-card flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b px-6 py-2 text-sm">
      <span>Book unavailable for this contract. The previous trade panel is closed.</span>
      {href && <Link className="text-primary underline" to={href}>Open event details</Link>}
      {onViewRecord && (
        <button type="button" className="text-primary underline" onClick={(e) => onViewRecord(e.currentTarget)}>View record</button>
      )}
      <button type="button" className="text-muted-foreground ml-auto underline" onClick={onDismiss}>Dismiss</button>
      <span className="text-muted-foreground basis-full break-all font-mono text-xs">{ticker}</span>
    </div>
  );
}
